import axios from "axios";


export const formatBytes = (bytes)  => {
	
    var marker = 1024; // Change to 1000 if required
    var decimal = 3; // Change as required
    var kiloBytes = marker; // One Kilobyte is 1024 bytes
    var megaBytes = marker * marker; // One MB is 1024 KB
    var gigaBytes = marker * marker * marker; // One GB is 1024 MB
  
    if(bytes < kiloBytes) return bytes + " Bytes";
    else if(bytes < megaBytes) return(bytes / kiloBytes).toFixed(decimal) + " KB";
    else if(bytes < gigaBytes) return(bytes / megaBytes).toFixed(decimal) + " MB";
    else return(bytes / gigaBytes).toFixed(decimal) + " GB";
}

export const filterCars = (models) => {
	let cars = [];
	models.cars.forEach((car) => {
		if (!cars.includes(car.producerLabel + " " +car.label)) {
			cars.push(car.producerLabel + " " +car.label);
		}
	});
	return cars;
}


export const calcMonth = (amount, month)  => {
	let number =  (amount+(amount*6.99/100)) / month;
	return Number(number).toLocaleString("de-DE", {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " €";
}

export const calcTotal = (amount)  => {
	let number =  (amount+(amount*6.99/100));
	return Number(number).toLocaleString("de-DE", {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " €";
}

export const formatNumber = (local, number)  => {
	if (isNaN(number))
		return "";
	else	
		return Number(number).toLocaleString("de-DE", {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " €";
}


export async function msgSendAI(msg) {
	let obj = {query: msg};
	const {data} = await axios.post(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/queryquestion", 
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	);

	console.log(data);
	return data; 
}

export async function postFile(formData) {
		await axios.post(process.env.REACT_APP_BACKEND_HOST + "/v1/action/file", formData, {
		    headers: {
		      'Content-Type': 'multipart/form-data'
		    }
		})
}

export async function getExternal(code, producer, params) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/external/configuration/"+ producer +"/"+code, 
	    params,
	        {headers: {'x-profile-key': "profileKey"}}
	        );
	    return data; 
}

export async function executeRefresh(params) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/executeRefresh", 
	    params,
	        {headers: {'x-profile-key': "profileKey"}}
	        );

		var db = JSON.stringify(data);
		let result = JSON.parse("{" + data + "}");

	    return result; 
}

export async function getConfigurationCode(params) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/configurations/newCode", 
	    params,
	        {headers: {'x-profile-key': "profileKey"}}
	        );

		var db = JSON.stringify(data);
		let result = JSON.parse("{" + data + "}");

	    return result; 
}

export async function requestPDFs(params) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/requestPdfs", 
	    params,
	        {headers: {'Content-Type': "application/json"}}
	        );
//let data;

	    return data; 
	    
}

export async function requestCarImages(params) {
	return null;
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/requestCarImages", 
	    params,
	        {headers: {'Content-Type': "application/json"}}
	        );

//let data;
	    return data; 

}

export async function getCarImages(params, path) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/requestGitTree/" + path, 
	    params,
	        {headers: {'Content-Type': "application/json"}}
	        );

	    return data; 
	    
}


export async function requestConfigPdf(obj, id) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/requestConfigPdf/" + id, 
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	     );
	    return data; 
}

export async function getConfigurations(params) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/configurations/", 
	    params,
	        {headers: {'x-profile-key': "profileKey"}}
	        );


	    return data; 
}


export async function getConfigurationsTotal(params) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/configurations/total", 
	    params,
	        {headers: {'x-profile-key': "profileKey"}}
	        );

		var db = JSON.stringify(data);
		let result = JSON.parse("{" + data + "}");

	    return result; 
}

export async function postLanguage(obj, lng) {
	    
	    const {data} = await axios.post(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/postLanguage/" + lng,
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	     );
	    return data; 	    
}

export async function doLogin(obj) {
	    
	    const {data} = await axios.post(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/login",
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	     );
	    return data; 	    
}

export async function postTranslations(obj, type, lng) {
	    
	    const {data} = await axios.post(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/translations/"+ lng +"/" + type,
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	     );
	    return data; 	      
}

export async function getTranslations(params) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/translations/", 
	    params,
	        {headers: {'x-profile-key': "profileKey"}}
	        );

	    return data; 
}


export async function getLeads(params) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/leads/", 
	    params,
	        {headers: {'x-profile-key': "profileKey"}}
	        );

	    return data; 
}

export async function getLeadsTotal(params) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST + "/v1/action/leads/total", 
	    params,
	        {headers: {'x-profile-key': "profileKey"}}
	        );

		var db = JSON.stringify(data);
		let result = JSON.parse("{" + data + "}");

	    return result; 
}


export async function publishTranslationsJson(obj, type) {
	    const {data} = await axios.post(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/publishTranslationsJson/" + type, 
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	     );
	    return data; 
}

export async function publishModelsJson(obj, type) {
	    const {data} = await axios.post(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/publishModelsJson/" + type, 
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	     );
	    return data; 
}

export async function addNewCar(obj, type) {
	    const {data} = await axios.post(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/addNewCar/" + type, 
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	     );
	    return data; 
}

export async function publishLatestNewsJson(obj) {
	    const {data} = await axios.post(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/publishLatestNewsJson/", 
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	     );
	    return data; 
}

export async function sendAction(obj, type) {
	    const {data} = await axios.post(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/sendmail/" + type, 
	    	obj,
	        {headers: { 'Content-Type': "application/json"
	        		  }
	        }
	     );
	    return data; 
}

export async function loadConfig(config, email) {
	    const {data} = await axios.get(process.env.REACT_APP_BACKEND_HOST +  "/v1/action/loadDocument/" + config + "?email=" + encodeURIComponent(email), 
	        {headers: { 'Content-Type': "application/json",
				        'X-Source-Type': "REACT"
	        		  }
	        }
	     );
	    return data; 
}

export const createOfferPdf = async (obj) => {
    const response = await fetch(process.env.REACT_APP_BACKEND_HOST +'/v1/action/createoffer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
    });

    if (!response.ok) throw new Error('Download failed');

    // Hier liegt der Clou: Wir erwarten kein JSON, sondern ein Blob
    return await response.blob(); 
};

